import React from 'react';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { User } from 'new/entities/User';
import { Stack } from 'new/elements/Stack';
import LightningStatus from 'new/elements/LightningStatus';
import { ReactComponent as KeyIcon } from 'new/components/icons/key.svg';
import { useDispatch } from 'react-redux';
import { updateServiceKey, UpdateServiceKeyDataParam } from 'js/actions';
import { ServiceKeyDetailHeaderMenu } from 'src/new/components/settings/Authentication/ServiceKeys/ServiceKeyDetailHeaderMenu';

import styles from './styles.module.scss';

interface ServiceKeyDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  owner: User;
  data: any;
  isEditable: any;
  isDetected: boolean;
  disableEditMessage: any;
  isManaged: any;
  connectionOrVendorType: any;
  statsContentView: any;
  showPipelineButton?: boolean;
  showTransform?: boolean;
  showSend?: boolean;
}

const Connection = ResourceDetailHeader.TopContent.Connection;

export const ServiceKeyDetailHeader = (props: ServiceKeyDetailHeaderProps) => {
  const dispatch = useDispatch();
  const { readOnly, adminAccess, data, isDetected, statsContentView } = props;
  const connection = { ...data, isDetected };

  const dispatchUpdateServiceKey = (serviceKeyID: number, data: UpdateServiceKeyDataParam) => {
    dispatch(updateServiceKey(serviceKeyID, data));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      updateInfo={dispatchUpdateServiceKey}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <Connection
              data={connection}
              iconSmall={<KeyIcon />}
              resourceType="CARD_TYPE_SERVICE_KEY"
            />
            <div className={styles.status}>
              <LightningStatus status={data.status?.toUpperCase()} />
            </div>
          </Stack>
          <Stack direction="row" alignItems="center" gap="16px">
            <ServiceKeyDetailHeaderMenu data={data} />
          </Stack>
        </Stack>
      </ResourceDetailHeader.TopContent>
      {statsContentView}
    </ResourceDetailHeader>
  );
};
